import React, {
  Fragment,
  useEffect,
  useContext,
  useState,
  useCallback,
} from 'react';
import { AppContext } from '../../core/Contexts/AppContext';
import { sendMail } from '../../core/services/mail-service';
import { useNavigate } from 'react-router-dom';

const Contact = () => {
  const { setTitle, setHeaderType } = useContext(AppContext);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });
  const [status, setStatus] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    setTitle('კონტაქტი');
    setHeaderType(0);
  }, [setTitle, setHeaderType]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      try {
        // Send formData as JSON with keys: name, email, phone, message
        const response = await sendMail(formData);
        console.log('Email sent successfully', response);
        if (response.status === '200') {
          setStatus('success');
          setFormData({ name: '', email: '', phone: '', message: '' });
        } else {
          setStatus('error');
        }
      } catch (error) {
        console.error('Error sending email:', error);
        setStatus('error');
      }
    },
    [formData]
  );

  // When the modal button is clicked, clear the status and redirect home.
  const handleClose = () => {
    setStatus('');
    navigate('/');
  };

  // Modal inline styles for a responsive, centered overlay
  const modalStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
      padding: '20px',
    },
    modal: {
      backgroundColor: '#fff',
      padding: '20px',
      borderRadius: '8px',
      width: '100%',
      maxWidth: '400px',
      textAlign: 'center',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
    },
    text: {
      fontSize: '18px',
      margin: '0 0 20px 0',
      lineHeight: '1.4',
    },
    button: {
      padding: '10px 20px',
      fontSize: '16px',
      border: 'none',
      borderRadius: '4px',
      backgroundColor: '#007bff',
      color: '#fff',
      cursor: 'pointer',
    },
  };

  return (
    <Fragment>
      <section className='position-relative'>
        <img
          src='../../images/contact_bg.jpg'
          className='images__wrap-contact'
          alt='Contact Background'
        />
        <div className='wrapper__bg-blue'></div>
        <div className='container position-relative z-2'>
          <div className='row'>
            <div className='col-md-7 mb-4 my-md-auto'>
              <p className='semi-bold font__size--18 text__16-1024 color__white'>
                კონტაქტი
              </p>
              <h3 className='bold font__size--58 text__50-1024 text__50-sm text__50-xs color__white mb-4'>
                ცხელი ხაზი: 14 83
              </h3>
              <p className='roboto normal font__size--16 text__16-1024 color__white mb-5'>
                სამუშაო დრო: ორშაბათი - პარასკევი 9:00-18:00
              </p>

              <div className='mb-5'>
                <h5 className='semi-bold font__size--18 text__16-1024 color__white mb-3'>
                  CONTACT US
                </h5>

                <div className='d-flex align-items-center'>
                  <img src='./../images/gfd (1).png' alt='Email Icon' />
                  <span className='ml-2 semi-bold font__size--18 text__16-1024 color__white text-uppercase'>
                    info@msa.gov.ge
                  </span>
                </div>

                <div className='d-flex align-items-center my-3'>
                  <img src='./../images/gfd (6).png' alt='Phone Icon' />
                  <span className='ml-2 semi-bold font__size--18 text__16-1024 color__white'>
                    14 83
                  </span>
                </div>

                <div className='d-flex align-items-center'>
                  <img src='./../images/gfd (5).png' alt='Address Icon' />
                  <span className='ml-2 semi-bold font__size--18 text__16-1024 color__white'>
                    ჩარგლის ქ. # 67, მე-7 სართული, თბილისი, ნაძალადევის რაიონი,
                    0178
                  </span>
                </div>
              </div>

              <h5 className='semi-bold font__size--14 text__14-1024 color__white text-uppercase mb-3'>
                გამოგვყევით
              </h5>

              <div className='d-flex align-items-center'>
                <a href='#!'>
                  <img src='./../images/gfd (4).png' alt='Social 1' />
                </a>
                <a href='#!' className='mx-3'>
                  <img src='./../images/gfd (3).png' alt='Social 2' />
                </a>
                <a href='#!'>
                  <img src='./../images/gfd (2).png' alt='Social 3' />
                </a>
              </div>
            </div>
            <div className='col-md-5 col-xl-5'>
              <div className='wrapper__form-contact bg__white rounded-lg'>
                <h3 className='bold font__size--32 text__32-1024 color__black text-uppercase mb-4'>
                  დაგვიკავშირდით
                </h3>
                <form onSubmit={handleSubmit}>
                  <div className='form-group'>
                    <label className='semi-bold font__size--14 text__14-1024'>
                      სახელი, გვარი*
                    </label>
                    <input
                      type='text'
                      name='name'
                      className='form-control wrapper__field'
                      placeholder='შეიყვანეთ სახელი და გვარი'
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className='form-group'>
                    <label className='semi-bold font__size--14 text__14-1024 text-uppercase'>
                      Email*
                    </label>
                    <input
                      type='email'
                      name='email'
                      className='form-control wrapper__field'
                      placeholder='ელ-ფოსტა'
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  <div className='form-group'>
                    <label className='semi-bold font__size--14 text__14-1024'>
                      ტელეფონი
                    </label>
                    <input
                      type='text'
                      name='phone'
                      className='form-control wrapper__field'
                      placeholder='ტელეფონი'
                      value={formData.phone}
                      onChange={handleChange}
                    />
                  </div>
                  <div className='form-group mb-4'>
                    <label className='semi-bold font__size--14 text__14-1024'>
                      შენიშვნა
                    </label>
                    <textarea
                      name='message'
                      className='form-control wrapper__field textarea'
                      cols='30'
                      rows='5'
                      placeholder='შეტყობინება...'
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>

                  <button
                    type='submit'
                    className='semi-bold font__size--14 text__14-1024 btn btn__outlined--blue color__blue no__opacity rounded-2 shadow'
                  >
                    გაგზავნა
                  </button>
                </form>
                {status === 200 && (
                  <p>თქვენი შეტყობინება წარმატებით გაიგზავნა!</p>
                )}
                {status === 'error' && (
                  <p style={{ color: 'red', marginTop: 10 }}></p>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className='map'>
        <iframe
          src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2975.8290231798546!2d44.79253562724269!3d41.76734399800463!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40446d9e7f669233%3A0x7ae32a2f9f663803!2s67%20Chargali%20St%2C%20T&#39;bilisi!5e0!3m2!1sen!2sge!4v1731607626351!5m2!1sen!2sge'
          width='100%'
          height='450'
          title='map'
          frameBorder='0'
          allowFullScreen
          loading='lazy'
          referrerPolicy='no-referrer-when-downgrade'
        />
      </div>

      {/* Success Modal */}
      {status === 'error' && (
        <div style={modalStyles.overlay}>
          <div style={modalStyles.modal}>
            <p style={modalStyles.text}>
              თქვენი შეტყობინება გაიგზავნა წარმატებით
            </p>
            <button onClick={handleClose} style={modalStyles.button}>
              დახურვა
            </button>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Contact;
